export { default as useHideInjectedContent } from './useHideInjectedContent';
